import React from 'react';

const TransactionDetails = ({ transaction, onClose }) => {
  if (!transaction) return null;

  const statusColors = {
    approved: 'bg-green-100 text-green-800',
    pending: 'bg-yellow-100 text-yellow-800',
    rejected: 'bg-red-100 text-red-800',
    completed: 'bg-blue-100 text-blue-800'
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-white">Transaction Details</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-white focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Left Column */}
            <div className="space-y-4">
              <div>
                <h3 className="text-sm font-medium text-gray-400">Transaction ID</h3>
                <p className="mt-1 text-white">{transaction.transactionId || 'N/A'}</p>
              </div>
              
              <div>
                <h3 className="text-sm font-medium text-gray-400">Game</h3>
                <p className="mt-1 text-white">{transaction.gameName || 'N/A'}</p>
              </div>
              
              <div>
                <h3 className="text-sm font-medium text-gray-400">Gems</h3>
                <p className="mt-1 text-white">
                  {parseInt(transaction?.coin || 0, 10).toLocaleString()}
                </p>
              </div>
            </div>

            {/* Right Column */}
            <div className="space-y-4">
              <div>
                <h3 className="text-sm font-medium text-gray-400">Status</h3>
                <span className={`mt-1 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                  statusColors[transaction.status?.toLowerCase()] || 'bg-gray-100 text-gray-800'
                }`}>
                  {transaction.status?.charAt(0).toUpperCase() + transaction.status?.slice(1) || 'N/A'}
                </span>
              </div>
              
              <div>
                <h3 className="text-sm font-medium text-gray-400">Receiver Coin</h3>
                <p className="mt-1 text-white">
                  {parseInt(transaction?.receiverCoin || 0, 10).toLocaleString()}
                </p>
              </div>
              
              <div>
                <h3 className="text-sm font-medium text-gray-400">Transaction Date</h3>
                <p className="mt-1 text-white">{formatDate(transaction.createdAt)}</p>
              </div>
              
              <div>
                <h3 className="text-sm font-medium text-gray-400">Last Updated</h3>
                <p className="mt-1 text-white">
                  {transaction.updatedAt ? formatDate(transaction.updatedAt) : 'N/A'}
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8 flex justify-end space-x-3">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionDetails;
